import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatBoxComponent } from './chat-box/chat-box.component';
import { ChatTicketListComponent } from './chat-ticket-list/chat-ticket-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CarouselComponentModule } from '../carousel/carousel.component';
import { SanitizeHtmlPipe } from './chat-box/sanitizeHtml.pipe';

@NgModule({
  imports: [
    CommonModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    CarouselComponentModule
  ],
  declarations: [
    ChatBoxComponent,
    ChatTicketListComponent,
    SanitizeHtmlPipe
  ],
  exports: [
    ChatTicketListComponent,
    ChatBoxComponent
  ]
})
export class SupportChatModule { }
